<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-p-6">
    <div class="ts-space-y-4">
      <label
        class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
        style="height: 45px;">
        <i class="fa fa-id-card fa-fw fa-lg ts-pb-1" style="color: white;"></i>
        <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.memberCard') }}</h4>
      </label>
      <div class="ts-border-t ts-border-gray-300 ts-pt-4">
        <div class="pos pos-counter">
          <div class="pos-counter-body">
            <div class="pos-counter-content">
              <vue-custom-scrollbar class="pos-counter-content-container">
                <ts-loading-banner :loading="false">
                  <div class="table-row">
                    <TableCard v-for="(table, index) in tableLists" :key="index" :table="table"
                      :selected="checkSelected(table)" @click="onTableSelected(table)" />
                  </div>
                </ts-loading-banner>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
        <div class="ts-py-1">
          <i>
            <span class="ts-text-xs">
              {{ $t('restaurantSale.selectOrScanKey') }}
            </span>
          </i>
        </div>
      </div>
      <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
        <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
          {{ $t('restaurantSale.back') }}</ts-button>
      </div>
    </div>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import TableCard from './MemberCardTableCard.vue'

export default {
  props: ['tableSelected', 'ref_customer_member_card_id'],
  name: 'linkedKeys',
  components: {
    RecieptPreview,
    TableCard
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      waiting: false,
      isScanning: false,
    }
  },
  created() { },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
        .filter(table => table.status_id == 1 && table.guest_level_id == 1)
    },
    customerMemberCards() {
      return this.$store.state.restaurantSale.counterCheckout.customer_member_cards
    },
  },
  methods: {
    checkSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      return selected ? true : false
    },
    onTableSelected(table) {
      table.ref_customer_member_card_id = this.ref_customer_member_card_id
      table.pre_charge_payment_method = 5

      let packagePromotion = this.customerMemberCards.find(el => el.customer_member_card_id == this.ref_customer_member_card_id)

      table = {
        ...table,
        checking_type: packagePromotion.promotion_type_id,
        pre_charge_bank_id: null,
        pre_charge_bank_account_number: null,
        invoice_detail: packagePromotion ? packagePromotion.package_promotion.details.map(el => ({
          amount: el.sub_total,
          discount_amount: el.discount_amount,
          discount_rate: el.discount_rate,
          discount_type: el.discount_type,
          grand_total: el.grand_total,
          is_allow_adjust_free_quantity: false,
          is_pre_charge: true,
          max_person: null,
          product_id: el.product_id,
          promo_free_item_cond_id: null,
          promo_type_id: null,
          quantity: el.quantity,
          remarks: null,
          service_length: el.service_length,
          total_after_discount: el.grand_total,
          unit_price: el.unit_price,
          uom_id: el.uom_id,
          vat_amount: el.vat_amount,
          vat_rate: el.vat_rate,
        })) : [],
      }

      this.$emit('onTableSelected', table)
    },
  }
}
</script>
<style scoped lang="scss">
.pos-counter {
  padding-top: 0;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }

}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>